var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackArrows(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 33,
    viewBox: "0 0 57 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5132 15.6325C23.843 16.0167 23.843 16.9833 24.5132 17.3675L46.4266 29.9309C47.0933 30.3132 47.924 29.8319 47.924 29.0634L47.924 3.93659C47.924 3.16814 47.0933 2.68684 46.4266 3.06905L24.5132 15.6325Z",
    fill: "#FAB55A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.23022 15.6325C1.56005 16.0167 1.56005 16.9833 2.23022 17.3675L24.1437 29.9309C24.8103 30.3132 25.641 29.8319 25.641 29.0634L25.641 3.93659C25.641 3.16814 24.8103 2.68684 24.1437 3.06905L2.23022 15.6325Z",
    fill: "#FAB55A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrows);
export default __webpack_public_path__ + "static/media/Back_Arrows.74d90c213171438d0d0caf5f69f38865.svg";
export { ForwardRef as ReactComponent };